import React, {
  AnimationEventHandler,
  useCallback,
  useEffect,
  useState,
} from "react";
import { isArray } from "lodash";
import classnames from "classnames";

import { CustomComponent } from "../../../store/types";
import { OptionsHash } from "./Dropdown-collection";
import {
  DropdownBodyProps,
  IDropdownOption,
  ObjectValue,
} from "./dropdown-types";

export const DropdownBody: React.FC<DropdownBodyProps> = ({
  isOpen,
  theme = "standard",
  options,
  onChange,
  value,
}): JSX.Element => {
  type AnimationStatus = "default" | "close" | "open";

  const [animationStatus, setAnimationStatus] =
    useState<AnimationStatus>("default");

  useEffect(() => {
    if (isOpen && animationStatus === "default") {
      setAnimationStatus("open");
    } else if (!isOpen && animationStatus === "open") {
      setAnimationStatus("close");
    }
  }, [isOpen]);

  const OptionComponent: CustomComponent<IDropdownOption> = OptionsHash[theme];

  type CheckIsSelectedType = (item: string | ObjectValue) => boolean;
  const checkIsSelected: CheckIsSelectedType = useCallback(
    (item) => {
      const isItemString: boolean = typeof item === "string";
      const isValueArray = isArray(value);
      if (!value) {
        return false;
      }
      return isItemString
        ? isValueArray
          ? (value as string[]).includes(item as string)
          : value === item
        : isValueArray
        ? (value as ObjectValue[])?.findIndex(
            (el: ObjectValue) => el.id === (item as ObjectValue).id
          ) !== -1
        : (value as ObjectValue).id === (item as ObjectValue).id;
    },
    [value]
  );

  const animationHandler: AnimationEventHandler<HTMLDivElement> = useCallback(
    ({ animationName }) => {
      if (animationName === "list-closing") {
        setAnimationStatus("default");
      }
    },
    []
  );

  return (
    <div
      onAnimationEnd={animationHandler}
      className={classnames(
        "content",
        `content--${theme}`,
        `content--${animationStatus}`
      )}>
      {animationStatus !== "default"
        ? (options as Array<string | ObjectValue>)?.map(
            (item: string | ObjectValue, index: number) => {
              const textValue =
                typeof item === "string"
                  ? item
                  : item?.presentation_name || item?.name || item?.title;
              if (OptionComponent) {
                return (
                  <OptionComponent
                    key={index}
                    onClick={async () => await onChange(item)}
                    value={textValue as string}
                    isSelected={checkIsSelected(item)}
                    theme={theme}
                  />
                );
              }
            }
          )
        : null}
    </div>
  );
};
